'use client';

import Script from 'next/script';
import { useEffect, useState } from 'react';
import { isBrowser } from '../../../utils/isBrowser';

export default function IZootoScript() {
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    if ('requestIdleCallback' in window) {
      const id = requestIdleCallback(() => setShouldLoad(true), {
        timeout: 5000,
      });

      return () => cancelIdleCallback(id);
    }

    const id = setTimeout(() => setShouldLoad(true), 5000);

    return () => clearTimeout(id);
  }, []);

  if (!shouldLoad) return null;

  return (
    <Script
      id="izooto-script"
      src="https://cdn.izooto.com/scripts/c7a0fd94b3925d18ff66ddfb9110ae008e6d6bc6.js"
      strategy="afterInteractive"
      onLoad={() => {
        if (!isBrowser()) return;

        // @ts-ignore
        window._izq = window._izq || [];
        // @ts-ignore
        window._izq.push(['init']);
      }}
    />
  );
}